export class ContactInformation {
  constructor(firstName, lastName, email, phone, secondContactFirstName, secondContactLastName, secondContactEmail, secondContactPhone, selectedLoanOfficer, selectedLoanOfficerToContact, rateAlertOptIn) {
    this.firstName = firstName ?? '';
    this.lastName = lastName ?? '';
    this.email = email ?? '';
    this.phone = phone ?? '';
    this.secondContactFirstName = secondContactFirstName ?? '';
    this.secondContactLastName = secondContactLastName ?? '';
    this.secondContactEmail = secondContactEmail ?? '';
    this.secondContactPhone = secondContactPhone ?? '';
    this.selectedLoanOfficer = selectedLoanOfficer ?? '';
    this.selectedLoanOfficerToContact = selectedLoanOfficerToContact ?? '';
    this.rateAlertOptIn = rateAlertOptIn ?? false;
  }

  static fromProspect(prospect) {
    return new ContactInformation(
      prospect.first_name,
      prospect.last_name,
      prospect.email,
      prospect.phone,
      prospect.second_contact_first_name,
      prospect.second_contact_last_name,
      prospect.second_contact_email,
      prospect.second_contact_phone,
      prospect.loan_officer_id,
      prospect.application_data?.confirmLoanOfficerToContact ?? 'Yes',
      prospect.rate_alert_opt_in,
    );
  }
}
